// pragmatic email format check: something@something.tld, no whitespace
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const isValidEmail = (v) => typeof v === 'string' && EMAIL_RE.test(v.trim())
